<template>
  <ReportChartCard :title="t('report.charts.utilization_amount')">
    <VueApexCharts class="bg-white" type="bar" :options="chartOptionsPercent" :series="seriesPercentage" height="350" />
    <VueApexCharts class="bg-white" type="bar" :options="chartOptionsHour" :series="seriesHour" height="350" />
  </ReportChartCard>
</template>

<script setup lang="ts">
import { useI18n } from '@/composable/useI18n'
import { useReportStore } from '@/store/report'
import { useUtilizationAmountHoursChart, useUtilizationAmountPercentageChart } from '@/utils/components/utilization-amount-chart'
import VueApexCharts from 'vue3-apexcharts'
import ReportChartCard from './ReportChartCard.vue'

const { t } = useI18n()
const store = useReportStore()

const { chartOptionsPercent, seriesPercentage } = useUtilizationAmountPercentageChart(
  store.getAmountEnergySensorUtilizationPercentage,
  store.getCompareAmountEnergySensorUtilizationPercentage,
)
const { chartOptionsHour, seriesHour } = useUtilizationAmountHoursChart(
  store.getAmountEnergySensorUtilizationHours,
  store.getCompareAmountEnergySensorUtilizationHours,
)
</script>
